var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Actions, ofActionCompleted, Select, Store } from '@ngxs/store';
import { QueryNodeInfoSuccess, QueryNodeInfoFailure, SetNodeInfo, ToggleVisibleNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { ViewActions } from '../../state/view.actions';
import { ViewState } from '../../state/view.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
export class ViewNodeDescriptionComponent {
    // ---------- Lifecycle ----------
    constructor(store, actions, changeRef) {
        this.store = store;
        this.actions = actions;
        this.changeRef = changeRef;
        // ---------- Input / Output ----------
        this.layout = 'drawer';
        this.showClose = true;
        this.isOpen = false;
        // ---------- Class Variables ----------
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.initInfoListeners();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    // ---------- Interaction ----------
    handleHideClick(node) {
        this.store.dispatch(new ToggleVisibleNodes([node], false));
    }
    handleCloseClick() {
        const layout = this.store.selectSnapshot(ViewState.getLayout);
        layout.nodeInfo.status = ViewLayoutStatus.Hide;
        this.store.dispatch(new ViewActions.SetLayout(layout));
    }
    // ---------- Methods ----------
    initInfoListeners() {
        // mark "dirty" check for node updates
        this.actions
            .pipe(ofActionCompleted(QueryNodeInfoSuccess, QueryNodeInfoFailure, SetNodeInfo), takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.isOpen = true;
            this.changeRef.markForCheck();
        });
    }
    formatHTML(text) {
        return text
            .trim()
            .replace(new RegExp('\r?\n', 'g'), '<br><br>');
    }
}
__decorate([
    Select(EngineNodesState.getSelectedNode),
    __metadata("design:type", Observable)
], ViewNodeDescriptionComponent.prototype, "node$", void 0);
__decorate([
    Select(EngineNodesState.getQuerying),
    __metadata("design:type", Observable)
], ViewNodeDescriptionComponent.prototype, "querying$", void 0);
